import { AppEventTypes } from "./appEventTypes"

export type PageViewedPayload = {
  screen: string
  screenConstant?: string
  /** Pathname at track time — Mixpanel `$current_url` can lag after client redirects. */
  routePath?: string
  operator?: string
  asset?: string
  [key: string]: unknown
}

/**
 * Matches `buxus-frontend` `google-analytics.ts`: Firebase `screen_view` uses this `screen_name` shape.
 */
export function buildGaStyleScreenName(properties: PageViewedPayload | undefined): string {
  if (!properties) return "View unknown"
  const op = properties.operator ? `${properties.operator} - ` : ""
  const asset = properties.asset ? `${properties.asset} - ` : ""
  return `${op}${asset}View ${properties.screen}`
}

/** Type guard helper for callers that branch on event name. */
export function isPageViewedEvent(
  eventName: string,
): eventName is typeof AppEventTypes.PAGE_VIEWED {
  return eventName === "page_viewed"
}
